/* eslint-disable import/order */
import { summarySoftwareEmbedEntrypoint } from '@jira/spa-apps__summary/src/summarySoftwareEmbedEntrypoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { softwareSummaryEmbedClassicRoute } from '@jira/router-routes__classic-projects-routes/src/softwareSummaryEmbedClassicRoute.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const summarySoftwareEmbedPageEntrypoint = createChromelessEntryPoint({
	main: summarySoftwareEmbedEntrypoint,
});

export const softwareSummaryEmbedClassicRouteEntry: Route = createEntry(
	softwareSummaryEmbedClassicRoute,
	() => ({
		group: 'classic-software',
		ufoName: 'classic-summary',
		layout: chromelessLayout,

		resources: [
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			// end of resources expanded from getNavigationSidebarProjectResource
		],

		entryPoint: () => {
			return summarySoftwareEmbedPageEntrypoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
